import Splide from "@splidejs/splide";
import '@splidejs/splide/css/core';

// =====================================================
// トップページの「施工事例」スライダー
// =====================================================
const worksSlider = document.querySelector( ".c-works__slide" );

if ( worksSlider )
{
    new Splide( worksSlider, {
        type: "loop",
        padding: { left: '15%', right: '15%' },
        gap: "1.6rem",
        pagination: true,
        arrows: false,

        classes: {
            page: 'splide__pagination__page c-works__page',
        },
    } ).mount();
}

// =====================================================
// トップページの「商品を探す」検索モーダル(台数・メーカー等)の開閉
// =====================================================
const modalSearchTriggers = document.querySelectorAll( ".js-modal-search-trigger" );

modalSearchTriggers.forEach( ( trigger ) =>
{
    trigger.addEventListener( "click", ( event ) =>
    {
        event.preventDefault();

        const modal = document.getElementById( trigger.dataset.modalTarget );
        if ( modal )
        {
            modal.classList.add( "is-open" );
        }
    } );
} );

// モーダル内の閉じるボタン・オーバーレイクリックで、開いているモーダルを閉じる
const modalSearchCloseButtons = document.querySelectorAll( ".js-modal-search-close" );

modalSearchCloseButtons.forEach( ( closeButton ) =>
{
    closeButton.addEventListener( "click", () =>
    {
        const modal = closeButton.closest( ".js-modal-search" );
        if ( modal )
        {
            modal.classList.remove( "is-open" );
        }
    } );
} );